import { type StackProps, View, YStack } from 'smoothie';

import type { ContainerComponent } from '../types/Common';

export const FullPageContainer = ({ children, ...stackProps }: StackProps) => {
    return (
        <YStack
            justifyContent="flex-start"
            alignItems="center"
            width="96%"
            marginTop="3vh"
            padding="2%"
            $lg={{ width: '92%', padding: '3%' }}
            backgroundColor="white"
            borderRadius={32}
            gap={48}
            {...stackProps}
        >
            {children}
        </YStack>
    );
};

export const PageContentContainer = ({
    children,
    ...stackProps
}: StackProps) => {
    return (
        <YStack
            justifyContent="flex-start"
            alignItems="center"
            margin="0.5%"
            padding="1.5%"
            $lg={{ margin: '0.75%', padding: '2.5%' }}
            backgroundColor="white"
            borderRadius={32}
            {...stackProps}
        >
            {children}
        </YStack>
    );
};

export const AuxContainer: ContainerComponent = ({ children }) => {
    return (
        <View
            style={{
                display: 'flex',
                flex: 1,
                backgroundColor: 'white',
                width: '94%',
                maxWidth: 600,
                height: 'auto',
                maxHeight: 400,
                alignSelf: 'center',
                justifySelf: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 32,
                padding: 32,
            }}
        >
            {children}
        </View>
    );
};
